module.exports = __webpack_public_path__ + "media/vo-03-05.436d74e3.mp3";